"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeFormContent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/components/site-menu/component");
const form_parts_1 = require("@front/components/form-parts");
const component_2 = require("@front/components/google-drive-file-picker/component");
const component_3 = require("@front/layouts/default-layout/component");
const events_1 = require("@front/components/form-parts/events");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const WSService_audio_1 = __importStar(require("@front/services/WSService.audio"));
const helpers_1 = require("@front/components/knowledge-picker/helpers");
const console_1 = require("@rws-framework/console");
require("@front/components/rag-settings/component");
component_2.GoogleDriveFilePicker;
//@ts-ignore                
let rwsTemplate = T.html `<the-form :onSubmit="${(x, c) => x.sendForm.bind(x)}">
  <div class="row">
    <div class="col-md-8">
      <div class="form-group">
        <part-input class="form-part" label="${'knowledge.form.title.label'.t()}" :value="${x => x.form.title}"
          name="title" placeholder="${'knowledge.form.title.placeholder'.t()}" required="true"></part-input>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <part-select class="form-part" label="${'knowledge.form.project.label'.t()}"
          :value="${x => x.form.projectId}" name="projectId"
          placeholder="${'knowledge.form.project.placeholder'.t()}"
          :options="${x => [{ label: 'knowledge.no_project'.t(), value: '' }, ...x.projects.map(project => ({ label: project.name, value: project.id }))]}">
        </part-select>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">        
        <part-radio class="form-part" label="knowledge.form.contentType.label" :value="${x => x.form.contentType}"
          name="contentType" :onChange="${x => x.changeContentType}" :options="${x => x.contentTypeOptions}"></part-radio>
        <small class="form-text text-muted">${'knowledge.form.contentType.help'.t()}</small>
        ${(0, fast_element_1.when)(x => x.googleDriveAuthenticated === false, (0, fast_element_1.html) `
          <div class="alert alert-warning mt-2" role="alert">
            <i class="bi bi-exclamation-triangle-fill"></i>
            <small>${'knowledge.form.googleDrive.notConnected'.t()}</small>
            <a @click="${(x, c) => x.handleSettingsRedirect(c.event)}" href="/settings/general" class="text-decoration-none ms-1"><small><u>${'knowledge.form.googleDrive.connect'.t()}</u></small></a>
          </div>
        `)}
      </div>
    </div>
    <div class="col-md-6">      
      <div class="form-group" ?hidden="${x => x.contentType !== 'file'}">
        <part-file-upload name="upload" mode="file" :uploadStarted="${x => x.uploadsInProgress.upload.status}" :uploadProgress="${x => x.uploadsInProgress.upload.progress}" :value="${x => x.form.currentFile}" label="${'knowledge.form.file.label'.t()}"
          placeholder="${'knowledge.form.file.placeholder'.t()}"></part-file-upload>
        ${(0, fast_element_1.when)(x => x.form.contentType === 'file' && x.knowledgeId && x.form.currentFile, (0, fast_element_1.html) `<button class="btn btn-sm btn-info reindex-btn" @click="${(x, c) => x.reindexFile(c.event)}">
          ${'knowledge.reindex'.t()} <i class="simple-icon-reload"></i>
        </button>`)}
      </div>
      <div class="form-group" ?hidden="${x => x.contentType !== 'link'}">
        <part-input class="form-part" required="false" label="${'knowledge.form.link.label'.t()}" :value="${x => x.form.content}"
          name="content" placeholder="${'knowledge.form.link.placeholder'.t()}"></part-input>
      </div>

      <div class="form-group" ?hidden="${x => x.contentType !== 'google-drive'}">
        <label class="form-label">${'knowledge.form.googleDrive.label'.t()}</label>
        
        
        ${(0, fast_element_1.when)(x => x.hasGoogleDriveFileSelected, (0, fast_element_1.html) `
          <div class="d-flex align-items-center gap-2 mb-2">
            <div class="flex-grow-1">
              <div class="input-group">
                <span class="input-group-text">
                  <i class="simple-icon-cloud-download"></i>
                </span>
                <div class="form-control d-flex align-items-center">
                  <a :href="${x => { var _a; return (_a = x.selectedGoogleDriveFile) === null || _a === void 0 ? void 0 : _a.url; }}" target="_blank" class="text-decoration-none text-truncate">
                    ${x => { var _a; return (_a = x.selectedGoogleDriveFile) === null || _a === void 0 ? void 0 : _a.name; }}
                  </a>
                </div>
                <button type="button" class="btn btn-outline-danger ml-3" @click="${x => x.clearGoogleDriveFile()}" title="${'common.clear'.t()}">
                  <i class="simple-icon-close"></i>
                </button>
              </div>
            </div>
          </div>
        `)}
        
        
        ${(0, fast_element_1.when)(x => !x.hasGoogleDriveFileSelected, (0, fast_element_1.html) `
          <div class="d-flex align-items-center gap-2 mb-2">
            <input type="text" class="form-control mr-3" :value="${x => x.form.content}" name="content" 
                   placeholder="${'knowledge.form.googleDrive.placeholder'.t()}" readonly>
            
            
            <google-drive-file-picker 
              buttonClass="btn btn-outline-primary"
              @file-selected="${(x, c) => x.onGoogleDriveFileSelected(c.event)}"
              @picker-cancelled="${x => x.onPickerCancelled()}">
            </google-drive-file-picker>
          </div>
        `)}
        
        <small class="form-text text-muted" ?hidden="${x => x.googleDriveAuthenticated}">
          <i class="bi bi-exclamation-triangle text-warning"></i>
          ${'knowledge.form.googleDrive.notConnected'.t()}
          <a href="/settings/general" class="text-decoration-none ms-1">${'knowledge.form.googleDrive.connect'.t()}</a>
        </small>
      </div>

      <div class="form-group" ?hidden="${x => x.contentType !== 'text'}">
        <part-textarea class="form-part" label="${'knowledge.form.content.label'.t()}" :value="${x => x.form.content}"
          name="content" rows="10" placeholder="${'knowledge.form.content.placeholder'.t()}"></part-textarea>
      </div>
    </div>
  </div>

  <div class="row"> 
    <div class="col-md-12">
      <div class="form-group">
        <part-textarea class="form-part" label="${'knowledge.form.description.label'.t()}"
          :value="${x => x.form.description}" name="description"
          rows="3" placeholder="${'knowledge.form.description.placeholder'.t()}"></part-textarea>
        <small class="form-text text-muted">${'knowledge.form.description.help'.t()}</small>
      </div>
    </div>
  </div>

  <div class="form-group">
    <part-tags class="form-part" label="${'knowledge.form.tags.label'.t()}" :value="${x => x.form.tags}" name="tags"></part-tags>
    <small class="form-text text-muted">${'knowledge.form.tags.help'.t()}</small>
  </div>

  <div class="form-group">
    <part-switch class="form-part" label="${'knowledge.form.timed.label'.t()}" :value="${x => x.form.timed}" name="timed">
    </part-switch>
    <small class="form-text text-muted">${'knowledge.form.timed.help'.t()}</small>
  </div>

  ${(0, fast_element_1.when)(x => x.form.timed, (0, fast_element_1.html) `
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <part-date class="form-part" label="${'knowledge.form.startTime.label'.t()}" :value="${x => x.form.startTime}"
          name="startTime" placeholder="${'knowledge.form.startTime.placeholder'.t()}"></part-date>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <part-date class="form-part" label="${'knowledge.form.endTime.label'.t()}" :value="${x => x.form.endTime}"
          name="endTime" placeholder="${'knowledge.form.endTime.placeholder'.t()}"></part-date>
      </div>
    </div>
  </div>
  `)}

  ${(0, fast_element_1.when)(x => x.isUserSuperAdmin, (0, fast_element_1.html) `
  <div class="form-group">
    <part-checkbox class="form-part" label="${'knowledge.native'.t()}" :value="${x => x.form.native}" name="native">
    </part-checkbox>
    <small class="form-text text-muted">${'knowledge.native.help'.t()}</small>
  </div>
  `)}

  ${(0, fast_element_1.when)(x => x.isUserParentOrAdmin, (0, fast_element_1.html) `
  <div class="form-group">
    <part-checkbox class="form-part" label="${'knowledge.active'.t()}" :value="${x => x.form.active}" name="active">
    </part-checkbox>
    <small class="form-text text-muted">${'knowledge.active.help'.t()}</small>
  </div>
  `)}



  <div class="form-group mt-3">     
      <part-switch label="${'knowledge.form.ragOverride.title'.t()}" name="ragOverrideEnabled" :value="${x => x.form.ragOverrideEnabled}"></part-switch>      
      ${(0, fast_element_1.when)(x => x.form.ragOverrideEnabled, (0, fast_element_1.html) `<div class="pt-3"><rag-settings 
        indexing="true"
        searching="false"
        @rag-settings-changed="${(x, c) => x.onRagOverrideChanged(c.event)}"
        :ragSettings="${x => x.ragOverrideSettings}">
      </rag-settings></div>`)}
  </div>

  <div class="form-group mt-4">
    <button type="button" @click="${(x, c) => x.sendSubmit(x, c)}" class="btn btn-primary btn-lg mr-2"
      ?disabled="${x => x.loading}">
      <span ?hidden="${x => !x.loading}" class="spinner-border spinner-border-sm me-2"></span>
      ${x => x.knowledgeId ? 'common.update'.t() : 'common.create'.t()}
    </button>
    ${(0, fast_element_1.when)(x => !x.isModalMode, (0, fast_element_1.html) `
    <button @click="${(x, c) => x.cancel(c.event)}" class="btn btn-secondary btn-lg">
      ${'common.cancel'.t()}
    </button>
    `)}
  </div>
</the-form>`;
const styles = null;
const shadowOptions = { "mode": "open" };
let KnowledgeFormContent = class KnowledgeFormContent extends client_1.RWSViewComponent {
    constructor(popupService, wsService) {
        super();
        this.popupService = popupService;
        this.wsService = wsService;
        this.loading = false;
        this.projects = [];
        this.googleDriveAuthenticated = false;
        this.selectedGoogleDriveFile = null; // Store selected file details
        this.isModalMode = false;
        this.knowledgeId = null;
        this.contentType = 'file';
        this.formOverride = null;
        this.form = {
            title: '',
            content: '',
            description: '',
            currentFile: null,
            tags: [],
            projectId: '',
            isActive: true,
            active: true,
            native: false,
            contentType: 'file',
            timed: false,
            startTime: null,
            endTime: null,
            ragOverride: undefined,
            ragOverrideEnabled: false
        };
        this.ragOverrideSettings = {};
        this.uploadsInProgress = {
            upload: { status: false, progress: 0 }
        };
        this.contentTypeOptions = [
            { label: 'knowledge.form.contentType.file', value: 'file' },
            { label: 'knowledge.form.contentType.text', value: 'text' },
            { label: 'knowledge.form.contentType.link', value: 'link' },
            { label: 'knowledge.form.contentType.googleDrive', value: 'google-drive' }
        ];
        this.sendSubmit = form_parts_1.FormComponent.sendSubmitEvent;
        this.changeContentType = (e) => {
            const target = e.target;
            this.contentType = target.value;
            // If Google Drive is selected, check authentication
            if (this.contentType === 'google-drive') {
                this.checkGoogleDriveStatus();
            }
            else {
                // Clear Google Drive state when switching away from Google Drive
                this.googleDriveAuthenticated = false;
                this.selectedGoogleDriveFile = null;
            }
        };
    }
    async connectedCallback() {
        super.connectedCallback();
        this.knowledgeId = this.routeParams.id;
        // Load projects
        await this.loadProjects();
        // Load knowledge data if editing
        if (this.knowledgeId) {
            await this.loadKnowledge();
        }
        else if (this.isModalMode) {
            // Reset form when opening modal for new knowledge creation
            this.resetForm();
        }
        await this.checkGoogleDriveStatus();
        this.on(events_1.inputEvents.changed, (event) => {
            if (event.detail.fieldName === 'timed') {
                if (event.detail.value === false) {
                    this.form = { ...this.form, startTime: undefined, endTime: undefined };
                }
                return;
            }
            if (event.detail.fieldName === 'upload') {
                this.form = { ...this.form, currentFile: event.detail.value };
                const val = event.detail.value;
                if ((!this.form.title || this.form.title === '') && val) {
                    this.form = { ...this.form, title: val.originalName || val.filename || '' };
                }
                return;
            }
            form_parts_1.FormComponent.assignFormValues.bind(this)('form', event);
        });
        if (this.formOverride) {
            this.form = { ...this.form, ...this.formOverride };
            if (this.formOverride.contentType) {
                this.contentType = this.formOverride.contentType;
            }
            // Handle base64 content for file uploads
            const override = this.formOverride; // Type assertion to handle additional properties
            console.log({ override });
            if (override.isBase64Content && override.contentType === 'file' && override.content) {
                await this.handleBase64FileContent(override);
            }
        }
    }
    get isUserSuperAdmin() {
        var _a;
        return ((_a = component_3.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
    }
    get isUserParentOrAdmin() {
        var _a, _b, _c;
        return ((_a = component_3.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN || ((_b = component_3.DefaultLayout.USER) === null || _b === void 0 ? void 0 : _b.role) === backendImport_1.UserRoles.PARENT_USER || ((_c = component_3.DefaultLayout.USER) === null || _c === void 0 ? void 0 : _c.role) === backendImport_1.UserRoles.ENTERPRISE;
    }
    get hasGoogleDriveFileSelected() {
        return this.contentType === 'google-drive' && !!this.selectedGoogleDriveFile;
    }
    isModalModeChanged() {
        // If modal mode is being enabled and we're not editing, reset the form
        if (this.isModalMode && !this.knowledgeId) {
            this.resetForm();
        }
    }
    onRagOverrideChanged(event) {
        if (event.detail && event.detail.settings) {
            this.ragOverrideSettings = { ...event.detail.settings };
            this.form = { ...this.form, ragOverride: this.ragOverrideSettings };
        }
    }
    async checkGoogleDriveStatus() {
        try {
            const response = await this.apiService.back.get('settings.google-drive.status');
            if (response && response.success && response.data) {
                this.googleDriveAuthenticated = response.data.enabled && response.data.authenticated;
                if (!this.googleDriveAuthenticated) {
                    this.notifyService.notify('knowledge.form.googleDrive.notAuthenticated'.t(), 'warning');
                }
            }
            else {
                console.error('Invalid Google Drive status response:', response);
                this.googleDriveAuthenticated = false;
            }
        }
        catch (e) {
            console.error('Failed to check Google Drive status:', e);
            this.googleDriveAuthenticated = false;
            this.notifyService.notify('knowledge.form.googleDrive.statusError'.t(), 'error');
        }
        if (!this.googleDriveAuthenticated) {
            this.contentTypeOptions = this.contentTypeOptions.filter(option => option.value !== 'google-drive');
        }
    }
    onGoogleDriveFileSelected(event) {
        const file = event.detail.file;
        // Store the file web view link in the content field
        this.form.content = file.webViewLink || `https://drive.google.com/file/d/${file.id}/view`;
        // Store the file details for display
        this.selectedGoogleDriveFile = {
            name: file.name,
            url: this.form.content,
            id: file.id
        };
        this.notifyService.notify('knowledge.form.googleDrive.fileSelected'.t(), 'info');
    }
    clearGoogleDriveFile() {
        this.form.content = '';
        this.selectedGoogleDriveFile = null;
        this.notifyService.notify('knowledge.form.googleDrive.fileCleared'.t(), 'info');
    }
    onPickerCancelled() {
        // Optional: Handle picker cancellation
        console.log('Google Drive picker was cancelled');
    }
    /**
     * Extract Google Drive file ID from various URL formats
     */
    extractGoogleDriveFileId(url) {
        if (!url)
            return null;
        // Pattern 1: /file/d/{fileId}/view or /file/d/{fileId}/edit
        let match = url.match(/\/file\/d\/([a-zA-Z0-9-_]+)/);
        if (match)
            return match[1];
        // Pattern 2: /document/d/{fileId}, /spreadsheets/d/{fileId}, /presentation/d/{fileId}
        match = url.match(/\/(document|spreadsheets|presentation)\/d\/([a-zA-Z0-9-_]+)/);
        if (match)
            return match[2];
        // Pattern 3: ?id={fileId}
        match = url.match(/[?&]id=([a-zA-Z0-9-_]+)/);
        if (match)
            return match[1];
        return null;
    }
    formChanged(oldV, newV) {
        this.form = newV;
    }
    resetForm() {
        this.form = {
            title: '',
            content: '',
            description: '',
            tags: [],
            projectId: '',
            isActive: true,
            active: true,
            currentFile: null,
            native: false,
            contentType: 'text',
            timed: false,
            startTime: undefined,
            endTime: undefined,
            ragOverride: undefined,
            ragOverrideEnabled: false
        };
        this.contentType = 'text';
        this.selectedGoogleDriveFile = null;
        this.ragOverrideSettings = {};
    }
    async loadProjects() {
        try {
            const response = await this.apiService.back.get('project.list', { queryParams: { all: '1' } });
            if (response.success && response.data) {
                this.projects = response.data;
            }
        }
        catch (error) {
            console.error('knowledge.form.projects.loadError'.t(), error);
        }
    }
    async loadKnowledge() {
        var _a;
        if (!this.knowledgeId)
            return;
        this.loading = true;
        try {
            const response = await this.apiService.back.get('knowledge.get', {
                routeParams: { id: this.knowledgeId }
            });
            if (response.success && response.data) {
                const contentType = response.data.contentType || 'text';
                this.contentType = contentType;
                this.form = {
                    title: response.data.title,
                    content: response.data.content,
                    description: response.data.description || '',
                    tags: response.data.tags || [],
                    currentFile: response.data.file || null,
                    native: response.data.native || false,
                    active: response.data.active !== undefined ? response.data.active : true,
                    contentType: contentType,
                    projectId: ((_a = response.data.project) === null || _a === void 0 ? void 0 : _a.id) ? String(response.data.project.id) : '',
                    timed: response.data.timed || false,
                    startTime: response.data.startTime ? console_1.DateUtils.create(response.data.startTime).date : null,
                    endTime: response.data.endTime ? console_1.DateUtils.create(response.data.endTime).date : null,
                    ragOverride: response.data.ragOverride || undefined,
                    ragOverrideEnabled: response.data.ragOverrideEnabled || false
                };
                if (response.data.ragOverride) {
                    this.ragOverrideSettings = { ...response.data.ragOverride };
                }
                // Handle Google Drive content type
                if (contentType === 'google-drive' && response.data.content && response.data.file) {
                    // Extract file name from the AppFile associated with the knowledge
                    const fileName = response.data.file.originalName || response.data.file.filename || 'Google Drive File';
                    // Set up the selected Google Drive file for display
                    this.selectedGoogleDriveFile = {
                        name: fileName,
                        url: response.data.content, // This is the Google Drive URL
                        id: this.extractGoogleDriveFileId(response.data.content)
                    };
                }
            }
            else {
                this.notifyService.notify(response.error || 'knowledge.form.load.error'.t(), 'error');
            }
        }
        catch (error) {
            console.error('knowledge.form.load.error'.t(), error);
            this.notifyService.notify('knowledge.form.load.error'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    async sendForm(event) {
        var _a;
        event.preventDefault();
        // Prevent multiple simultaneous submissions
        if (this.loading) {
            console.warn('knowledge.form.submit.duplicateWarning'.t());
            return;
        }
        if (this.contentType === 'file' && (!this.form.currentFile || (this.form.currentFile && this.form.currentFile.size === 0))) {
            this.popupService.alert('knowledge.form.validation.fileRequired'.t());
            return;
        }
        // Validate timed knowledge dates
        if (this.form.timed && (!this.form.startTime || !this.form.endTime)) {
            this.popupService.alert('knowledge.form.validation.timedDatesRequired'.t());
            return;
        }
        this.loading = true;
        let wsListenerSetup = false;
        try {
            let response;
            // Clean form data - ensure empty projectId is properly handled
            const formData = { ...this.form };
            if (!formData.projectId || formData.projectId.trim() === '') {
                formData.projectId = '';
            }
            // Handle date fields - convert DateUtils dates to ISO strings or ensure null values are preserved
            if (formData.startTime) {
                formData.startTime = console_1.DateUtils.create(formData.startTime).date;
            }
            else {
                formData.startTime = null;
            }
            if (formData.endTime) {
                formData.endTime = console_1.DateUtils.create(formData.endTime).date;
            }
            else {
                formData.endTime = null;
            }
            if (this.knowledgeId) {
                console.log('knowledge.form.submit.updating'.t(), this.knowledgeId);
                // response = await this.apiService.back.put<IKnowledgeResponse, IKnowledgePayload>('knowledge.update', formData, {
                //     routeParams: { id: this.knowledgeId }
                // });
            }
            else {
                console.log('knowledge.form.submit.creating'.t());
                // Set up WebSocket listener before sending POST for file uploads
                if (this.contentType === 'file' && formData.currentFile) {
                    // Use a temporary ID for tracking until we get the real knowledge ID
                    const tempId = Date.now().toString();
                    wsListenerSetup = true;
                    helpers_1.KnowledgeWebSocketHelper.setupKnowledgeListener(this.wsService, tempId, (knowledgeId) => {
                        this.notifyService.notify('knowledge.form.fileProcessing.completed'.t());
                        // Ensure any additional listeners are cleaned up
                        if (knowledgeId.toString() !== tempId) {
                            helpers_1.KnowledgeWebSocketHelper.cleanupKnowledgeListener(knowledgeId.toString());
                        }
                    }, (knowledgeId) => {
                        this.notifyService.notify('knowledge.form.fileProcessing.failed'.t(), 'error');
                        // Ensure any additional listeners are cleaned up  
                        if (knowledgeId.toString() !== tempId) {
                            helpers_1.KnowledgeWebSocketHelper.cleanupKnowledgeListener(knowledgeId.toString());
                        }
                    }, this.notifyService);
                }
                // response = await this.apiService.back.post<IKnowledgeResponse, IKnowledgePayload>('knowledge.create', formData);               
            }
            const file = (_a = formData.currentFile) === null || _a === void 0 ? void 0 : _a.path;
            if (file) {
                delete formData.currentFile.path;
            }
            this.uploadsInProgress = { ...this.uploadsInProgress, upload: { status: true, progress: 0 } };
            response = await this.apiService.back.uploadFiles(this.knowledgeId ? 'knowledge.update' : 'knowledge.create', { upload: file }, formData, {
                method: this.knowledgeId ? 'PUT' : 'POST',
                onProgress: (progress) => {
                    this.uploadsInProgress = { ...this.uploadsInProgress, upload: { status: true, progress } };
                }
            }, { routeParams: this.knowledgeId ? { id: this.knowledgeId } : undefined });
            this.uploadsInProgress = { ...this.uploadsInProgress, upload: { status: false, progress: 0 } };
            if (!response.success) {
                // The temporary listener will automatically clean up on error response
                const errorMessage = response.error || (this.knowledgeId ? 'knowledge.form.submit.updateError'.t() : 'knowledge.form.submit.createError'.t());
                this.notifyService.notify(errorMessage, 'error');
            }
            else {
                const successMessage = this.knowledgeId ? 'knowledge.form.submit.updateSuccess'.t() : 'knowledge.form.submit.createSuccess'.t();
                this.notifyService.notify(successMessage, 'info');
                // For successful uploads that don't need RAG processing, the listener will auto-cleanup
                // No manual cleanup needed here
                // Emit knowledge-saved event with the created/updated knowledge
                this.$emit('knowledge-saved', { knowledge: response.data });
                // For new knowledge creation, also emit knowledge-created event for backward compatibility
                if (!this.knowledgeId) {
                    this.$emit('knowledge-created', { knowledge: response.data });
                    this.resetForm();
                }
                // Navigate only if not in modal mode
                if (!this.isModalMode) {
                    component_1.SiteMenu.goto.bind(this)('/ai/knowledge/list');
                }
            }
        }
        catch (error) {
            console.error('knowledge.form.submit.error'.t(), error);
            // The temporary listener will clean up automatically on any error
            const errorMessage = this.knowledgeId ? 'knowledge.form.submit.updateError'.t() : 'knowledge.form.submit.createError'.t();
            this.notifyService.notify(errorMessage, 'error');
        }
        finally {
            this.loading = false;
        }
    }
    cancel(event) {
        event.preventDefault();
        if (this.isModalMode) {
            this.$emit('cancel');
        }
        else {
            component_1.SiteMenu.goto.bind(this)('/ai/knowledge/list');
        }
    }
    /**
     * Handle base64 file content from AI assistant signal
     */
    async handleBase64FileContent(override) {
        try {
            // Create IFile object from base64 content
            const fileObject = {
                filename: override.originalName || override.title || 'uploaded-file',
                originalName: override.originalName || override.title || 'uploaded-file',
                mimeType: override.mimeType || 'application/octet-stream',
                size: override.size || 0,
                path: override.content, // Store base64 data in path field
            };
            // Set the file object to the form
            this.form.currentFile = fileObject;
            // Also clear the content field since we're using file upload mode
            this.form.content = '';
        }
        catch (error) {
            console.error('Error processing base64 file content:', error);
            this.notifyService.notify('Error processing file content', 'error');
        }
    }
    handleSettingsRedirect(event) {
        event.preventDefault();
        component_1.SiteMenu.goto.bind(this)('/settings/general');
    }
    reindexFile(e) {
        e.preventDefault();
        this.apiService.back.get('knowledge.reindex', { routeParams: { id: this.routeParams.id } }).then(() => {
            component_1.SiteMenu.goto.bind(this)('/ai/knowledge/list');
        });
    }
};
exports.KnowledgeFormContent = KnowledgeFormContent;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], KnowledgeFormContent.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], KnowledgeFormContent.prototype, "projects", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], KnowledgeFormContent.prototype, "googleDriveAuthenticated", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], KnowledgeFormContent.prototype, "selectedGoogleDriveFile", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Boolean)
], KnowledgeFormContent.prototype, "isModalMode", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], KnowledgeFormContent.prototype, "knowledgeId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], KnowledgeFormContent.prototype, "contentType", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof backendImport_1.IKnowledgePayload !== "undefined" && backendImport_1.IKnowledgePayload) === "function" ? _c : Object)
], KnowledgeFormContent.prototype, "formOverride", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof backendImport_1.IKnowledgePayload !== "undefined" && backendImport_1.IKnowledgePayload) === "function" ? _d : Object)
], KnowledgeFormContent.prototype, "form", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_e = typeof backendImport_1.IRagOverride !== "undefined" && backendImport_1.IRagOverride) === "function" ? _e : Object)
], KnowledgeFormContent.prototype, "ragOverrideSettings", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_f = typeof Record !== "undefined" && Record) === "function" ? _f : Object)
], KnowledgeFormContent.prototype, "uploadsInProgress", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], KnowledgeFormContent.prototype, "contentTypeOptions", void 0);
exports.KnowledgeFormContent = KnowledgeFormContent = __decorate([
    (0, client_1.RWSView)('knowledge-form-content', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __param(1, (0, client_1.RWSInject)(WSService_audio_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object, typeof (_b = typeof WSService_audio_1.WSServiceAudioInstance !== "undefined" && WSService_audio_1.WSServiceAudioInstance) === "function" ? _b : Object])
], KnowledgeFormContent);
KnowledgeFormContent.defineComponent();
